import React from 'react';

import { ExpiredDateWrapper, TextContainer } from './styles';
import { Text, Spacer } from '../../.../../../../shared/components';

function formatDate(date) {
  return date.toLocaleDateString('pt-BR');
}

export default function ExpiredOrder({ expirationDate }) {
  return (
    <ExpiredDateWrapper>
      <TextContainer>
        <Text.h1> Seu pedido está expirado!</Text.h1>
        <Spacer.vertical size={20} />
        <Text.normal>
          A data de expiração foi {formatDate(expirationDate)}.
        </Text.normal>
        <Spacer.vertical size={10} />
        <Text.small>
          Entre em contato com o estabelecimento para mais informações.
        </Text.small>
      </TextContainer>
    </ExpiredDateWrapper>
  );
}
